module.exports = __webpack_public_path__ + "media/music/7c5a16e0627c64fd62ec597bb72b879d.mp3";